//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

import { NetworkType } from '@apis/content-library/contentLibraryApiModel';

export const getNetworkTypeLabel = (networkType: NetworkType) => {
  switch (networkType) {
    case NetworkType.BAZAARVOICE:
      return 'Bazaarvoice';
    case NetworkType.FACEBOOK:
      return 'Facebook';
    case NetworkType.INSTAGRAM:
      return 'Instagram';
    case NetworkType.MEDIA_IMPORT:
      return 'Uploaded Media';
    case NetworkType.PINTEREST:
      return 'Pinterest';
    case NetworkType.SNAPCHAT:
      return 'Snapchat';
    case NetworkType.TIKTOK:
      return 'TikTok';
    case NetworkType.TUMBLR:
      return 'Tumblr';
    case NetworkType.TWITTER:
      return 'X';
    case NetworkType.YOUTUBE:
      return 'YouTube';
    default:
      throw new Error(`Unsupported network type: ${networkType}`); // This should never happen if the switch is exhaustive.
  }
};
